import React from 'react';
import _ from 'lodash';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import InputButton from '../../../../../components/ZUILib/InputButton';
import TextInput from '../../../../../components/ZUILib/TextInput';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import * as typeActions from '../../actions';
import commonUtil from '../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

const { deleteBankOrCardDetails } = typeActions;

// const pageName = 'accountClosure';
export default class UserCardBankCreate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      transferenceData: this.props.transferenceData.transferenceOptions,

      selectedDropdownAvailableCardsInfoValue: '',
      selectedRadioSavedCardsInfoValue: '',
      isNuevaCuentaButtonDisabled: false,

      isUserHasCards: false,
      isAddBankCard: false,
      isAddBankCardDetail: false,

      cardBankAmount: '',
      accountNumber: '',
      beneficiaryName: '',

      isNuevaCuentaDisabled: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.state.transferenceData.savedCardsInfo && this.state.transferenceData.savedCardsInfo.length > 0) {
      this.setState({ isUserHasCards: true, isAddBankCard: false });
    } else {
      this.setState({ isUserHasCards: false, isAddBankCard: true });
    }
  }

  onUserBankCardClearState = () => {
    this.setState({
      accountNumber: '',
      beneficiaryName: '',
    });
    this.props.disableContinueButton(true);
  }

  onAddCardInputChange = (e) => {
    if (e.target.name === 'accountNumber') {
      const regEx = new RegExp('^[0-9]+$');
      this.state[e.target.name] = regEx.test(e.target.value) ? e.target.value : '';
      this.setState({ [e.target.name]: regEx.test(e.target.value) ? e.target.value : '' });
    } else {
      const regEx = new RegExp('^[a-zA-Z ]*$');
      this.state[e.target.name] = regEx.test(e.target.value) ? e.target.value : '';
      this.setState({ [e.target.name]: regEx.test(e.target.value) ? e.target.value : '' });
    }
    if (this.state.accountNumber.length > 0 && this.state.beneficiaryName.length > 0) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  onEliminarButtonClick = () => {
    deleteBankOrCardDetails(this.state.selectedRadioSavedCardsInfoValue).then((res) => {
      if (res.body.status.status === 'success') {
        const transferenceData = this.state.transferenceData;
        _.remove(transferenceData.savedCardsInfo, { accountId: this.state.selectedRadioSavedCardsInfoValue });
        this.setState({ transferenceData });
      }
    });
  }

  onNuevaCuentaClick = () => {
    this.onFormCardAmountDivClick();
    this.setState({ isNuevaCuentaDisabled: true, isAddBankCard: true });
    this.props.disableContinueButton(true);
  }

  onFormCardAmountDivClick = () => {
    this.setState({ selectedRadioSavedCardsInfoValue: '' });
    if ((this.state.accountNumber && this.state.accountNumber.length > 0) && (this.state.beneficiaryName && this.state.beneficiaryName.value.length > 0)) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  handleRadioSelected = (data, e) => {
    this.onUserBankCardClearState();
    this.setState({ selectedRadioSavedCardsInfoValue: e.target.value });
    this.props.disableContinueButton(false);
  }

  onAvailableCardsInfoSelectChange = (data, e) => {
    this.setState({ selectedDropdownAvailableCardsInfoValue: e.target.value, isAddBankCardDetail: true, selectedRadioSavedCardsInfoValue: '' });
  }
  getFormData = () => {
    let reqParams = {};
    if (this.state.selectedRadioSavedCardsInfoValue === '') {
      const availableCardsObj = _.find(this.state.transferenceData.availableCardsInfo, { accountName: this.state.selectedDropdownAvailableCardsInfoValue });
      reqParams = {
        paymentType: availableCardsObj.accountName,
        number: this.state.accountNumber,
        accountName: this.state.beneficiaryName,
      };
    } else {
      const savedCardsObj = _.find(this.state.transferenceData.savedCardsInfo, { accountId: this.state.selectedRadioSavedCardsInfoValue });
      reqParams = {
        paymentType: savedCardsObj.accountType,
        cardOrBankIdentifierId: this.state.selectedRadioSavedCardsInfoValue,
        cardNumber: savedCardsObj.accountNumber,
      };
    }
    return reqParams;
  }
  render() {
    const eliminarButtonJson = {
      name: 'Eliminar Tarjeta',
      type: 'button',
      autoFocus: false,
      classname: 'btnDelete size-Medium',
      cssStyle: { display: 'inline-grid' },
      value: 'Eliminar Tarjeta',
      onClickHandler: this.onEliminarButtonClick,
    };
    /* eslint-disable */
    const eliminarButton = (id) => {
      return (
        <React.Fragment>
          {this.state.selectedRadioSavedCardsInfoValue === id &&
            <React.Fragment>
              {channel === constChannels.WAP ?
                <i className="icon-basura" onClick={this.onEliminarButtonClick} /> :
                <InputButton buttonAttr={{ ...eliminarButtonJson, id: ('eliminarButton_' + id) }} />}
            </React.Fragment>
          }
        </React.Fragment>
      );
    };
    /* eslint-enable */

    const savedCardsInfo = {
      name: 'cardsInfo',
      options: [],
    };
    if (this.state.transferenceData && this.state.transferenceData.savedCardsInfo) {
      this.state.transferenceData.savedCardsInfo.map(card =>
        savedCardsInfo.options.push({
          id: 'radio_' + card.accountId,
          value: card.accountId,
          displayName: <span>{card.accountType}</span>,
          subDetailsHTML: (channel !== 'wap') && <div>{card.accountNumber}</div>,
          eliminarButton: eliminarButton(card.accountId),
          selected: false,
          innerContent: (channel === 'wap') && <React.Fragment>{eliminarButton(card.accountId)} <div className="accountNumber">{card.accountNumber}</div></React.Fragment>,
        }),
      );
    }

    const nuevaCuentaButtonJson = {
      name: 'Nueva cuenta / tarjeta',
      type: 'button',
      autoFocus: false,
      classname: 'btnSecondarySpecial size-Medium',
      value: 'Nueva cuenta / tarjeta',
      onClickHandler: this.onNuevaCuentaClick,
      disabled: this.state.isNuevaCuentaDisabled,
    };

    const availableCardsInfo = {
      id: 'availableCardsInfoDropdown',
      optionCaption: 'Selecciona el banco de destino',
      optionText: 'labelResourceId',
      optionValue: 'value',
      options: [],
    };
    if (this.state.transferenceData && this.state.transferenceData.availableCardsInfo) {
      this.state.transferenceData.availableCardsInfo.map(card =>
        availableCardsInfo.options.push({
          /* eslint-disable */
          value: card.accountName,
          labelResourceId: +card.commissionFee !== 0 ? card.accountName + ' ' + '(' + card.commissionFee + '%' + ' ' + 'comisión' + ')' :
            card.accountName + ' ' + '(' + 'Sin' + ' ' + 'comisión' + ')',
          /* eslint-enable*/
        }),
      );
    }

    return (
      <React.Fragment>
        {channel === constChannels.WAP ?
          <div>
            {this.state.isUserHasCards ?
              <div className="userbankcard-inneroptions">

                {savedCardsInfo.options.map((option, index) => (
                  <div className="innerOptions" key={index}>
                    <RadioButton checked={this.state.selectedRadioSavedCardsInfoValue === option.value} displayName={option.displayName} id={option.id} value={option.value} name="savedCardInfo" radioCssClass={'radio selectCard radioDF'} innerContent={option.innerContent} onChangeFunction={this.handleRadioSelected} />
                  </div>))}

                <div>
                  <SelectionTab
                    classname="cSelect required"
                    id={availableCardsInfo.id}
                    options={availableCardsInfo.options}
                    optionCaption={'Selecciona el banco de destino'}
                    optionText={'labelResourceId'}
                    optionValue={'value'}
                    handleSelectedOption={this.onAvailableCardsInfoSelectChange}
                    ref={cardSelectionPaymentType => this.cardSelectionPaymentType = cardSelectionPaymentType}
                  />
                  {this.state.isAddBankCardDetail ?
                    <div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Número de cuenta"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          maxlength="16"
                          name="accountNumber"
                          inputValue={this.state.accountNumber}
                          ref={txt => this.accountNumber = txt}
                        />
                      </div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Nombre del beneficiario"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          name="beneficiaryName"
                          maxlength="100"
                          inputValue={this.state.beneficiaryName}
                          ref={txt => this.beneficiaryName = txt}
                        />
                      </div>
                    </div>
                    : null}
                </div>
              </div>
              : null}
            {this.state.isAddBankCard ?
              <div className="display-block" id="blockNewAccount">
                <div className="col-xs-12+ offset-xs-8" onClick={this.onFormCardAmountDivClick}>

                  <SelectionTab
                    classname="cSelect required"
                    id={availableCardsInfo.id}
                    options={availableCardsInfo.options}
                    optionCaption={'Selecciona el banco de destino'}
                    optionText={'labelResourceId'}
                    optionValue={'value'}
                    handleSelectedOption={this.onAvailableCardsInfoSelectChange}
                    ref={cardSelectionPaymentType => this.cardSelectionPaymentType = cardSelectionPaymentType}
                  />
                  {this.state.isAddBankCardDetail ?
                    <div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Número de cuenta"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          maxlength="16"
                          name="accountNumber"
                          inputValue={this.state.accountNumber}
                          ref={txt => this.accountNumber = txt}
                        />
                      </div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Nombre del beneficiario"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          name="beneficiaryName"
                          maxlength="100"
                          inputValue={this.state.beneficiaryName}
                          ref={txt => this.beneficiaryName = txt}
                        />
                      </div>
                    </div>
                    : null}
                </div>
              </div>
              : null}
          </div>
          :
          <React.Fragment>
            <span className="titleForm">Selecciona cuenta o tarjeta</span>
            {this.state.isUserHasCards &&
              <div className="row display-block" id="blockAccount">
                <div className="col-xs-7">
                  <div>
                    {savedCardsInfo.options.map((option, index) => (
                      <div className="row" key={index}>
                        <div className="col-xs-7">
                          <RadioButton checked={this.state.selectedRadioSavedCardsInfoValue === option.value} displayName={option.displayName} id={option.id} value={option.value} name="savedCardInfo" radioCssClass={'radio selectCard radioDF'} subDetailsHTML={option.subDetailsHTML} onChangeFunction={this.handleRadioSelected} />
                        </div>
                        <div className="col-xs-5">
                          {option.eliminarButton}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-xs-2 col-xs-offset-3 display-block" id="blockAddAccounts">
                  {_.isEmpty(this.state.transferenceData.availableCardsInfo) ? null : <InputButton buttonAttr={nuevaCuentaButtonJson} />}
                </div>
              </div>}
            {this.state.isAddBankCard &&
              <div className="row display-block" id="blockNewAccount">
                <div className="col-xs-4 offset-xs-8" onClick={this.onFormCardAmountDivClick}>
                  <SelectionTab
                    classname="cSelect required"
                    id={availableCardsInfo.id}
                    options={availableCardsInfo.options}
                    optionCaption={'Selecciona el banco de destino'}
                    optionText={'labelResourceId'}
                    optionValue={'value'}
                    handleSelectedOption={this.onAvailableCardsInfoSelectChange}
                    ref={cardSelectionPaymentType => this.cardSelectionPaymentType = cardSelectionPaymentType}
                  />
                  {this.state.isAddBankCardDetail ?
                    <div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Número de cuenta"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          maxlength="16"
                          name="accountNumber"
                          inputValue={this.state.accountNumber}
                          ref={txt => this.accountNumber = txt}
                        />
                      </div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Nombre del beneficiario"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          name="beneficiaryName"
                          maxlength="100"
                          inputValue={this.state.beneficiaryName}
                          ref={txt => this.beneficiaryName = txt}
                        />
                      </div>
                    </div>
                    : null}
                </div>
              </div>}
          </React.Fragment>
        }
      </React.Fragment>


    );
  }
}
